import ComponentManager from '@/Management/ComponentManager';
import DropDownListFactory from '@/Factories/ControlFactories/DropDownListFactory';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import CustomSingleDropDownViewModel from '@/Components/CustomDropDown/CustomSingleDropDown/CustomSingleDropDownViewModel';

export default class CustomSingleDropDownFactory extends DropDownListFactory {

    /**
     * @override 
     */
    public context: DetailViewContext;

    public constructor(params) {
        super(params);
    }

    /**
     * @override 
     */
    protected createViewModel(params: object): CustomSingleDropDownViewModel {
        return new CustomSingleDropDownViewModel(params);
    }

    /**
     * @override 
     */
    protected createViewModelParameter(): any {
        const params = super.createViewModelParameter();
        params.dto = this.context.genericObject.getObservable<string>(this.detailViewItem.name);

        return params;
    }

    /**
     * Must be overwritten, parent class creates fake-property in generic object
     * Data is created in CustomSingleDropDownViewModel
     */
    public getData(): KnockoutObservableArray<any> {
        return null;
    }
}

ComponentManager.setFactory('CustomSingleDropDown', CustomSingleDropDownFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');